import { readonly, ref } from 'vue'

interface DomainConfig {
    documentTitle: string
    loginWelcomeText: string
    loginWelcomeDescription: string
    pcAdminUrl?: string
}

const defaultConfig: DomainConfig = {
    documentTitle: import.meta.env.VITE_APP_TITLE || 'OA管理系统',
    loginWelcomeText: '欢迎登录',
    loginWelcomeDescription: '智能赋能商业云端重塑管理，让企业运营更高效、更智慧'
}

const domainConfig = ref<DomainConfig>(defaultConfig)
let initialized = false

function getConfigUrl(): string {
    const hostname = window.location.hostname.toLowerCase()
    return `/domain-config/${hostname || 'localhost'}.json`
}

function normalizeConfig(value: unknown): DomainConfig {
    if (!value || typeof value !== 'object') return defaultConfig
    const config = value as Partial<DomainConfig>
    return {
        documentTitle: typeof config.documentTitle === 'string' ? config.documentTitle : defaultConfig.documentTitle,
        loginWelcomeText: typeof config.loginWelcomeText === 'string' ? config.loginWelcomeText : defaultConfig.loginWelcomeText,
        loginWelcomeDescription:
            typeof config.loginWelcomeDescription === 'string'
                ? config.loginWelcomeDescription
                : defaultConfig.loginWelcomeDescription,
        pcAdminUrl: typeof config.pcAdminUrl === 'string' ? config.pcAdminUrl : undefined
    }
}

async function fetchConfig(url: string): Promise<DomainConfig | null> {
    const response = await fetch(url, { cache: 'no-store' })
    if (!response.ok) return null
    return normalizeConfig(await response.json())
}

export async function initDomainConfig(): Promise<DomainConfig> {
    if (initialized) return domainConfig.value
    initialized = true

    try {
        domainConfig.value =
            (await fetchConfig(getConfigUrl())) ||
            (await fetchConfig('/domain-config/default.json')) ||
            defaultConfig
    } catch (error) {
        console.warn('[DomainConfig] Failed to load domain configuration.', error)
        domainConfig.value = defaultConfig
    }

    document.title = domainConfig.value.documentTitle
    return domainConfig.value
}

export function useDomainConfig() {
    return readonly(domainConfig)
}
